<template>
  <h1>[WIP] Search</h1>

  <NuxtLink :to="`/${route.params.locale}`">Go back Home</NuxtLink>

  <!-- <SkinnyBanner
    v-if="isSkinnyBannerAvailable('landing')"
    data-test="landing-skinny-banner"
    page="landing"
  /> -->
  <div>
    <!-- <ClientOnly>
      <TopLanding v-if="!searchHasResults" />
    </ClientOnly> -->
    <!-- <ProductResultsSection
      v-if="searchHasResults"
      class="md:mt-5"
      data-test="product-results-refinement"
      :filters="searchFilters"
      :is-loading="isLoading"
      @filter="updateQueryString"
      @reset-filters="resetFilters"
    /> -->
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from 'nuxt/app'

const route = useRoute()
</script>
